var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 63,
    viewBox: "0 0 184 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24974",
    "data-name": "Group 24974",
    transform: "translate(-96 -125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 184,
    height: 63,
    rx: 10,
    transform: "translate(96 125)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(146 148)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(149 174)",
    fill: "#fff",
    fontSize: 26,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")), /*#__PURE__*/React.createElement("g", {
    id: "apple-logo",
    transform: "translate(106.896 138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24973",
    "data-name": "Group 24973",
    transform: "translate(2.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164566",
    "data-name": "Path 164566",
    d: "M18.061,0h.246a7.4,7.4,0,0,1-1.863,5.576,5.776,5.776,0,0,1-5.085,2.387,7.177,7.177,0,0,1,1.9-5.4A8.192,8.192,0,0,1,18.061,0Z",
    transform: "translate(2.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164567",
    "data-name": "Path 164567",
    d: "M30.275,22.523v.068A20.1,20.1,0,0,1,27.4,28.137c-1.1,1.51-2.441,3.542-4.842,3.542-2.074,0-3.452-1.334-5.578-1.37-2.249-.036-3.485,1.115-5.541,1.405h-.7A6.261,6.261,0,0,1,7.12,29.222,21.828,21.828,0,0,1,2.1,16.665V15.118A10.127,10.127,0,0,1,6.526,6.806a7.467,7.467,0,0,1,5.013-1.161A12.612,12.612,0,0,1,14,6.35a6.783,6.783,0,0,0,2.455.736,5.893,5.893,0,0,0,1.722-.527,10.6,10.6,0,0,1,5.541-.983,7.688,7.688,0,0,1,5.649,3.369,7.249,7.249,0,0,0-3.683,7.192A7.425,7.425,0,0,0,30.275,22.523Z",
    transform: "translate(-2.104 2.841)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.97b1b78eb3410c06f315406467ce93c3.svg";
export { ForwardRef as ReactComponent };